const commonModule = {
  confirm: "確定",
  cancel: "取消",
  home: "主頁",
  search: "搜索",
  order: "訂單壹覽",
  coupon: "優惠券一覽",
  user: "我的",
  save: "保存",
  isDelete: "是否要刪除嗎?",
  isCancel: "是否要取消?",
  addSuccess: "新增成功",
  cancelSuccess: "取消成功",
  add: "新增",
  delete: "刪除",
  submit: "提交",
  emailFormat: "郵箱格式錯誤",
  example: "例",
  min: "分",
  noContent: "暂无数据",
  privateBrowse: "當前為無痕模式，請關掉無痕模式，確保功能正常使用",
  back: "返回",
  detail: "詳情",
  store: "店鋪",
  amount: "金額",
  loading: "加載中...",
  bn: "編號",
  goHome: "返回首頁",
  desc1:"正在出售的票",
  agree:"請先同意隱私政策",
  card:"選擇信用卡",
  point_list:"景點列錶",
  invoice:"請填寫內容",
  jpPhone:"日本 +81",
  cnPhone:"中國 +86",
  krPhone:"韓國 +82",
  hkPhone:"香港 +852",
  moPhone:"澳門 +853",
  twPhone:"臺灣 +886",
  useNum:"使用數量",
  useSuccess:"利用成功",
  isUse:"要利用嗎？",
  couponOrder:"訂單號",
  couponCount1:"可使用券數",
  couponCount2:"已使用券數",
  couponCount3:"過期券數",
  couponCount4:"獲得券數",
  couponTime:"獲得時間",
  couponShop:"店鋪名",
  couponAddr:"地址",
  couponStatus1:"未使用",
  couponStatus2:"部分使用",
  couponStatus3:"使用完畢",
  couponStatus4:"已過期",
  close:"關閉",
  comment: "評論",
  copy: "複製",
  copySuccess: "複製成功",
  copyFailed: "複製失敗",
};

export default commonModule;
